// extracted by mini-css-extract-plugin
export var fullHeight = "carousel-module--fullHeight--3O2hg";
export var slideWrapper = "carousel-module--slideWrapper--eIpR8";
export var maxWidth = "carousel-module--maxWidth--1VZdc";
export var circles = "carousel-module--circles--3Zk4R";
export var circleButton = "carousel-module--circleButton--4Sgvx";